import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login'),
      meta: { title: '登录', requiresAuth: false }
    },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      meta: { requiresAuth: true },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard'),
          meta: { title: '数据概览', icon: 'el-icon-s-data' }
        },
        {
          path: 'videos',
          name: 'Videos',
          component: () => import('@/views/Videos'),
          meta: { title: '视频管理', icon: 'el-icon-video-camera' }
        },
        {
          path: 'products',
          name: 'Products',
          component: () => import('@/views/Products'),
          meta: { title: '商品管理', icon: 'el-icon-goods' }
        },
        {
          path: 'questions',
          name: 'Questions',
          component: () => import('@/views/Questions'),
          meta: { title: '题库管理', icon: 'el-icon-edit' }
        },
        {
          path: 'exam-papers',
          name: 'ExamPapers',
          component: () => import('@/views/ExamPapers'),
          meta: { title: '试卷管理', icon: 'el-icon-document' }
        },
        {
          path: 'users',
          name: 'Users',
          component: () => import('@/views/Users'),
          meta: { title: '用户管理', icon: 'el-icon-user' }
        },
        {
          path: 'orders',
          name: 'Orders',
          component: () => import('@/views/Orders'),
          meta: { title: '兑换订单', icon: 'el-icon-s-order' }
        },
        {
          path: 'points-records',
          name: 'PointsRecords',
          component: () => import('@/views/PointsRecords'),
          meta: { title: '积分记录', icon: 'el-icon-coin' }
        },
        {
          path: 'policy-files',
          name: 'PolicyFiles',
          component: () => import('@/views/PolicyFiles'),
          meta: { title: '政策学习', icon: 'el-icon-document' }
        },
        {
          path: 'user-rank',
          name: 'UserRank',
          component: () => import('@/views/UserRank'),
          meta: { title: '用户排行榜', icon: 'el-icon-trophy' }
        },
        {
          path: 'notifications',
          name: 'Notifications',
          component: () => import('@/views/Notifications'),
          meta: { title: '消息通知', icon: 'el-icon-message' }
        },
        {
          path: 'categories',
          name: 'Categories',
          component: () => import('@/views/Categories'),
          meta: { title: '分类管理', icon: 'el-icon-menu' }
        }
      ]
    }
  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  // 如果访问登录页且已登录，跳转到首页
  if (to.path === '/login' && token) {
    next('/')
    return
  }
  
  // 如果需要认证且未登录，跳转到登录页
  if (to.matched.some(record => record.meta.requiresAuth) && !token) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }
  
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js